import * as React from "react";
import { set } from "dot-prop-immutable";
import { Upload as DesignUpload, Modal, message } from "@whalecloud/fdx";
import { ReactComponent as Add } from "@assets/icons/add.svg";
import { getLocale } from "@utils/util";

const UploadElement = (props) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const { data: { formItemSettings = {}, className = '' } = {} } = element;
  const {
    width = document.body.clientWidth / 2,
    height = document.body.clientHeight / 2 - 38.6,
    download,
    fileList: list = [],
    successMessage = messages["PAGEBUIDER_SETTINGS_UPLOAD_SUCCESS_DEFAULT"],
    errorMessage = messages["PAGEBUIDER_SETTINGS_UPLOAD_ERROR_DEFAULT"],
    failMessage = messages["PAGEBUIDER_SETTINGS_UPLOAD_FAILD_DEFAULT"],
    ...restProps
  } = formItemSettings;
  const typeList = formItemSettings?.accept?.split(",") || [];
  const uploadButton = (
    <div>
      <Add />
      <div style={{ marginTop: 8 }}>
        {messages["PAGEBUIDER_ELEMENT_FORM_UPLOAD"]}
      </div>
    </div>
  );
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const [fileList, setFileList] = React.useState(list);
  const [previewImage, setPreviewImage] = React.useState();
  const [previewVisible, setPreviewVisible] = React.useState(false);
  const [previewTitle, setPreviewTitle] = React.useState();
  const handlePreview = async (file) => {
    file.preview = await getBase64(file.originFileObj);
    setPreviewImage(file.preview);
    setPreviewVisible(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };
  const handleCancel = () => setPreviewVisible(false);

  const handleChange = (info) => {
    let fileList = [...info.fileList];
    fileList = fileList.map((file) => {
      if (file.status === "done") {
        // eslint-disable-next-line no-template-curly-in-string
        file.url = download.replace(
          "${id}",
          file.response[0][formItemSettings.fileIdName]
        );
      }
      return file;
    });
    if (info.file.status === "done") {
      message.success(successMessage);
    }
    if (info.file.status === "error") {
      message.error(failMessage);
    }
    const newElement = set(element, "data.formItemSettings.fileList", fileList);
    updateElement({
      element: newElement,
    });
    setFileList(fileList);
  };

  //文件类型校验
  const checkType = (file, typeList) => {
    return new Promise(function(resolve, reject) {
      let res = false;
      if (typeList.length === 0 || typeList.includes("*")) {
        res = true;
      } else {
        typeList.forEach((type) => {
          if (type === file.type) {
            res = true;
          }
          if (type === "image/*" && file.type.includes("image")) {
            res = true;
          }
        });
      }
      if (res) {
        resolve();
      } else {
        message.error(errorMessage);
        reject();
      }
    });
  };

  return (
    <React.Fragment>
      <DesignUpload
        listType="picture-card"
        {...restProps}
        download={download}
        beforeUpload={(file, fileList) => {
          return Promise.all([checkType(file, [...typeList])]);
        }}
        onChange={handleChange}
        fileList={fileList}
        onPreview={handlePreview}
        className={className}
      >
        {uploadButton}
      </DesignUpload>
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        width={width}
        bodyStyle={{
          height,
        }}
      >
        <img
          alt="example"
          height={height - 32}
          style={{ maxWidth: `${width - 32}` }}
          src={previewImage}
        />
      </Modal>
    </React.Fragment>
  );
};

export default UploadElement;
